import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.board.list');
import { OnInit, Input, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-board-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.board.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabBoardListComponent implements OnInit, OnChanges {
    @Input() workspace_id: string = '';
    @Input() category: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public workspace: any = null;
    public canWrite: boolean = false;
    public stats: any = { total: 0, notice: 0, general: 0, poll: 0, pinned: 0 };
    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public text: string = '';
    public categoryFilter: string = '';
    public loaded: boolean = false;

    public showCreate: boolean = false;
    public newPost: any = this.emptyPost();

    public ngOnChanges() {
        if (this.workspace_id) {
            this.categoryFilter = this.category || '';
            this.load();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        if (this.workspace_id) {
            this.categoryFilter = this.category || '';
            await this.load();
        } else {
            this.loaded = true;
        }
    }

    private emptyPost(): any {
        return { title: '', content: '', category: 'general', pinned: false, tags: [], poll: null };
    }

    public async load() {
        if (!this.workspace_id) {
            this.loaded = true;
            await this.service.render();
            return;
        }
        const res = await wiz.call('init', { workspace_id: this.workspace_id });
        if (res.code === 200) {
            this.workspace = res.data.workspace;
            this.canWrite = !!res.data.can_write;
            this.stats = res.data.stats || this.stats;
        }
        await this.search(true);
    }

    public async search(reset: boolean = true) {
        if (reset) this.page = 1;
        const res = await wiz.call('search', {
            workspace_id: this.workspace_id,
            category: this.categoryFilter,
            text: this.text,
            page: this.page,
            dump: this.dump,
        });
        if (res.code === 200) {
            this.rows = res.data.rows || [];
            this.total = res.data.total || 0;
        }
        this.loaded = true;
        await this.service.render();
    }

    public async setCategory(cat: string) {
        this.categoryFilter = cat;
        await this.search(true);
    }

    public open(post: any) {
        this.service.href(`/admin/collab/board/${this.workspace_id}/${post.id}`);
    }

    public openCreate() {
        if (!this.canWrite) {
            this.service.alert.error('쓰기 권한이 없습니다.');
            return;
        }
        this.newPost = this.emptyPost();
        if (this.categoryFilter) this.newPost.category = this.categoryFilter;
        this.showCreate = true;
    }

    public closeCreate() {
        this.showCreate = false;
    }

    public addPollOption() {
        if (!this.newPost.poll) {
            this.newPost.poll = { options: [], multi: false, anonymous: false };
        }
        const idx = this.newPost.poll.options.length;
        this.newPost.poll.options.push({ key: `opt_${Date.now()}_${idx}`, label: '', votes: [] });
    }

    public removePollOption(idx: number) {
        if (this.newPost.poll) {
            this.newPost.poll.options.splice(idx, 1);
        }
    }

    public togglePollEnable() {
        if (this.newPost.category === 'poll') {
            if (!this.newPost.poll) {
                this.newPost.poll = { options: [], multi: false, anonymous: false };
                this.addPollOption();
                this.addPollOption();
            }
        } else {
            this.newPost.poll = null;
        }
    }

    public addTag(ev: any) {
        const v = (ev.target.value || '').trim();
        if (v) {
            this.newPost.tags = this.newPost.tags || [];
            if (!this.newPost.tags.includes(v)) this.newPost.tags.push(v);
            ev.target.value = '';
        }
    }

    public removeTag(idx: number) {
        this.newPost.tags.splice(idx, 1);
    }

    public async create() {
        if (!this.newPost.title.trim()) {
            this.service.alert.error('제목을 입력하세요.');
            return;
        }
        if (this.newPost.category === 'poll') {
            const opts = this.newPost.poll?.options || [];
            const valid = opts.filter((o: any) => (o.label || '').trim());
            if (valid.length < 2) {
                this.service.alert.error('투표 항목을 2개 이상 입력하세요.');
                return;
            }
            this.newPost.poll.options = valid;
        }
        const payload = {
            workspace_id: this.workspace_id,
            title: this.newPost.title,
            content: this.newPost.content,
            category: this.newPost.category,
            pinned: this.newPost.pinned ? '1' : '',
            tags: JSON.stringify(this.newPost.tags || []),
            poll: this.newPost.poll ? JSON.stringify(this.newPost.poll) : '',
        };
        const res = await wiz.call('create', payload);
        if (res.code === 200) {
            this.showCreate = false;
            this.service.href(`/admin/collab/board/${this.workspace_id}/${res.data.id}`);
        } else {
            this.service.alert.error(res.data?.message || '생성 실패');
            await this.service.render();
        }
    }

    public categoryLabel(c: string): string {
        return c === 'notice' ? '공지' : c === 'poll' ? '투표' : '일반';
    }

    public categoryColor(c: string): string {
        if (c === 'notice') return 'bg-rose-100 text-rose-700 ring-1 ring-rose-200';
        if (c === 'poll') return 'bg-violet-100 text-violet-700 ring-1 ring-violet-200';
        return 'bg-zinc-100 text-zinc-700 ring-1 ring-zinc-200';
    }

    public formatDate(d: any): string {
        if (!d) return '';
        const dt = new Date(d);
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const day = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }
}

export default PortalLpsysadminCollabBoardListComponent;